import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { RESOURCES_VIDEOS } from "../../StaticData/Videos";
import "./Videos.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const Videos = () => {
  const [playingVideos, setPlayingVideos] = useState({});

  const handlePlay = (index, idx) => {
    setPlayingVideos((prev) => ({
      ...prev,
      [`${index}-${idx}`]: true, // Store playing state for each video
    }));
  };

  return (
    <div className="videos-page">
      <Helmet>
        <title>Videos | Idexcel</title>
        <meta content="" name="keywords" />
        <meta content="" name="description" />
      </Helmet>

      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="videos-banner-container p-0">
          <section className="videos-banner-section"></section>
        </Container>
      </motion.div>

      <Container
        fluid
        className="videos-section px-xl-5 d-flex justify-content-center"
      >
        <section className="my-5 px-xl-5">
          {RESOURCES_VIDEOS.map((resource, index) => (
            <Row key="videos-resource">
              {resource.videos.map((video, idx) => {
                const videoKey = `${index}-${idx}`;
                const isPlaying = playingVideos[videoKey];

                return (
                  <Col
                    lg={6}
                    md={6}
                    sm={12}
                    key={videoKey}
                    className="mb-4 px-xl-4 py-xl-3"
                  >
                    <Card className="cards">
                      <Card.Body className="video-card">
                        <Card.Title className="card-title">
                          {video.title}
                        </Card.Title>

                        <div className="video-wrapper">
                          {isPlaying ? (
                            <video
                              width="100%"
                              height="300"
                              controls
                              autoPlay
                              className="video-player"
                            >
                              <source src={video.videoLink} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <button
                              className="thumbnail-container"
                              onClick={() => handlePlay(index, idx)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  handlePlay(index, idx);
                                }
                              }}
                            >
                              <img
                                src={video.thumbnail}
                                alt="Video Thumbnail"
                                className="video-thumbnail"
                              />
                              <div className="play-button">
                                <i className="fa fa-play"></i>
                              </div>
                            </button>
                          )}
                        </div>

                        <Card.Text className="mt-3">{video.desc}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ))}
        </section>
      </Container>
    </div>
  );
};

export default Videos;
